import * as comp from "../lib/tiles/tiles";
import { useState } from "react";

const colors = {
    lightBlue: "#2196f3ff",
    darkBlue: "#0d47a1ff",
    grey: "#323232",
    white: "#ffffff",
    black: "#000000",
    TestingLightBlue: "#00c3ff",
};

function Home() {
    
    function getCachedData() {
        if (localStorage.getItem('cached') === null) {
            return "No Cached Data";
        }
        const data = JSON.parse(localStorage.getItem('cached'));
        return data.length > 0 ? String(data.length) + " Cached Data" : "No Cached Data";
    }

    function forceUpdate() {

        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
        alert("Complete Cache Cleared");
        localStorage.clear();
        window.location.href = '/';
    }

    function SubmitCacheData (route, check = "") {

        if(!check === "") {
            window.confirm(check);
            return;
        }

        const fetchRoute = process.env.REACT_APP_SERVER_URL + route;
    
        var data = [];
    
        if (localStorage.getItem('data') === null) {
            localStorage.setItem('data', JSON.stringify([]));
        } else {
            data = JSON.parse(localStorage.getItem('data'));
        }
        
        console.log("data: " + JSON.stringify(data))
    
        fetch(fetchRoute, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': process.env.REACT_APP_SERVER_URL,
                'Version': process.env.REACT_APP_VERSION
            },
            body: JSON.stringify(data)
        }).then((response) => {
            localStorage.setItem('cached', JSON.stringify([]));
            console.log(response);
            window.confirm("Data successfully sent to server.");
        }).catch((err) => {
            localStorage.setItem('cached', JSON.stringify(data));
            console.log(err);
            window.confirm("Unbable to send data to server. Retry or attempt at another location.")
        });
    }

    const [name, setName] = useState(localStorage.getItem('scoutName'));

    function setScoutName (name) {
        localStorage.setItem('scoutName', name)
        setName(name);
    }
    function checkVersion () {
        console.log("Checking Version");
        fetch(process.env.REACT_APP_SERVER_URL + '/api/version', {
            headers: {
                'version': process.env.REACT_APP_VERSION
            }
        }).then((response) => {
            response.json().then((data) => {
                console.log(data)
                if(data !== process.env.REACT_APP_VERSION) {
                    alert("Version Outdated. Please force update.")
                } else {
                    alert("Version Up to Date")
                }
            });
        });
    }

    return (
        <div>
            <comp.Row alignment={"center"}>
                <h1 >Chilly Scout</h1>
            </comp.Row>
            <comp.Row alignment={"center"}>
                <comp.TextEntry label="Enter Your Name" width="80vw" height="15vh" placeholder={name} onChange={setScoutName}/>
            </comp.Row>
            <comp.Row alignment={"center"}>
                <comp.Button label="Scouting Sheet" width="80vw" height="25vh" color={colors.darkBlue} onChange={() => window.location.href = '/scouting'}/>
            </comp.Row>
            <comp.Row alignment={"center"}>
                <div>
                    <comp.Button label="Match List" width="50vw" height="20vh" color={colors.darkBlue} onChange={() => window.open('https://www.thebluealliance.com/event/2025wasno', "_blank", "noreferrer")}/>
                    <comp.Button label={"Submit " + getCachedData()} width="50vw" height="20vh" color={colors.darkBlue} onChange={() => SubmitCacheData('/api/data/create')}/>
                </div>
                <div>
                    <comp.Button width="30vw" height="20vh" color={colors.darkBlue} label="Check Version" onChange={checkVersion}/>
                    <comp.Button width="30vw" height="20vh" color={colors.darkBlue} label="Force Update" onChange={forceUpdate}/>
                </div>
            </comp.Row>
        </div>
    )
}

export default Home;